import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import $ from 'jquery'
import { Card, Tooltip } from '@mui/material'

import { Logger, LoggerTypes } from '../../../../utils'
import { setFlowGroupAttributeTab } from '../../../../actions'
import './style.scss'

export const FlowConditionCard = ({ condition }) => {
  const dispatch = useDispatch()

  const name = condition?.name || ''
  const description = condition?.description || ''

  const errorOverClassName = '__elementErrorOver'
  const centerElement = $('.commonPage_container_central.twoSections')
  const rightElement = $('.commonPage_container_lateral.right')

  const onConditionClick = (e, element_id) => {
    e.preventDefault()
    e.stopPropagation()

    Logger.trace(LoggerTypes.CONTROLLER, 'FlowTaskCard.onConditionClick()', { element_id })

    rightElement.removeClass('close').addClass('open')
    centerElement.removeClass('close').addClass('open')

    dispatch(setFlowGroupAttributeTab(element_id, { type: 'bpmn:ExclusiveGateway', id: element_id }))
  }

  const onConditionOver = (e, element_id) => {
    e.preventDefault()
    e.stopPropagation()

    const _el = $(`[data-element-id="${element_id}"]`)
    const _elLabel = $(`[data-element-id="${element_id}_label"]`)

    // Logger.trace(LoggerTypes.CONTROLLER, 'FlowTaskCard.onConditionOver()', { element_id })

    if (_el) {
      _el.addClass(errorOverClassName)
      if (_elLabel) {
        _elLabel.addClass(errorOverClassName)
      }
    }
  }

  const onConditionOut = (e, element_id) => {
    e.preventDefault()
    e.stopPropagation()

    const _el = $(`[data-element-id="${element_id}"]`)
    const _elLabel = $(`[data-element-id="${element_id}_label"]`)

    // Logger.trace(LoggerTypes.CONTROLLER, 'FlowTaskCard.onConditionOut()', { element_id })

    if (_el) {
      _el.removeClass(errorOverClassName)
      if (_elLabel) {
        _elLabel.removeClass(errorOverClassName)
      }
    }
  }

  // Logger.trace(LoggerTypes.CONTAINER, 'FlowConditionCard.render()', {
  //   condition,
  //   _condition: {
  //     name,
  //     description
  //   }
  // })

  return (
    <Card className="FlowConditionCard common-card">
      <Tooltip title={description}>
        <div
          onClick={(e) => onConditionClick(e, condition.element_id)}
          onMouseOver={(e) => onConditionOver(e, condition.element_id)}
          onMouseOut={(e) => onConditionOut(e, condition.element_id)}
        >
          <b>{name}</b>
        </div>
      </Tooltip>
    </Card>
  )
}

FlowConditionCard.displayName = 'FlowConditionCard'

FlowConditionCard.propTypes = {
  condition: PropTypes.object.isRequired
}

FlowConditionCard.defaultProps = {
  condition: null
}
